<template>
  <multiple_form
    :forms="forms"
    :edit="props.canEdit"
    :editData="props.editData"
    :disabled="props.disabled"
    :disabledDate="disabledDate"
    ref="multipleFormRef"
    @submit="handelSubmit"
  />
</template>
<script setup>
  import { ref, defineProps, defineEmits, computed } from 'vue'
  import { useStore } from 'vuex'
  import { message } from 'ant-design-vue'
  import {
    createData,
    updateData,
  } from '@/api/person_application/person_application'
  import multiple_form from '@/components/multiple_form'
  import { gender, yesOrNot, areaTypeConst } from '@/utils/common'
  import { constantToOptions } from '@/utils/format'
  import dayjs from 'dayjs'

  const disabledDate = (current) => {
    return current && current < dayjs().subtract(1,'days').endOf('day')
  }

  //初始化
  const props = defineProps({
    isEdit: Boolean,
    canEdit: Boolean,
    editData: Object,
    data: Array,
    idField: String,
    disabled: Boolean,
  })
  const emit = defineEmits(['submit'])

  // vuex
  const store = useStore()

  //编辑、新增的表单
  const forms = computed(() => [
    {
      name: '来访人员信息',
      id: 'visitor',
      formItem: [
        {
          type: 'input',
          field: 'visitor_name',
          label: '姓名',
        },
        {
          type: 'radio',
          field: 'visitor_gender',
          options: constantToOptions(gender),
          label: '性别',
        },
        {
          type: 'input',
          field: 'visitor_nation',
          label: '民族',
        },
        // {
        //   type: 'input',
        //   field: 'visitor_education',
        //   label: '学历',
        // },
        {
          type: 'input',
          field: 'visitor_phone',
          label: '手机号码',
        },
        // {
        //   type: 'radio',
        //   field: 'veteran',
        //   options: constantToOptions(yesOrNot),
        //   label: '退役军人',
        // },
        {
          type: 'input',
          field: 'visitor_company',
          label: '申请人工作单位',
        },
        {
          type: 'input',
          field: 'visitor_address',
          label: '申请人现住址(详细)',
        },
        {
          type: 'radio',
          storeOptions: 'personVisitType',
          field: 'visitor_type',
          label: '访客类型',
          onChange: ({ target }) => {
            // 保存到全局
            store.dispatch('common/setCurrentVisitorType', target.value)
            // 清空来访/截止时间
            const formRefs = multipleFormRef?.value?.formRefs
            const visitForm = formRefs?.visit
            if (visitForm?.formState) {
              visitForm.formState.visit_begin_time = ''
              visitForm.formState.visit_end_time = ''
            }
          },
        },
        {
          type: 'select',
          field: 'visitor_idcard_type',
          storeOptions: 'documentType',
          label: '证件类型',
        },
        {
          type: 'input',
          field: 'visitor_idcard',
          label: '证件号码',
        },
        {
          type: props.canEdit ? 'imgUpload' : 'image',
          field: 'visitor_face_photo',
          label: '人脸图片',
        },
        {
          type: props.canEdit ? 'imgUpload' : 'image',
          field: 'visitor_idcard_photo1',
          label: '证件图片-人像面(原件)',
        },
        {
          type: props.canEdit ? 'imgUpload' : 'image',
          field: 'visitor_idcard_photo2',
          label: '证件图片-国徽面(原件)',
        },
      ],
    },
    {
      name: '来访信息',
      id: 'visit',
      formItem: [
        {
          type: 'input',
          field: 'visit_content',
          label: '访问事由',
        },
        {
          type: 'dateRange',
          startField: 'visit_begin_time',
          endField: 'visit_end_time',
          label: '来访/截止时间',
        },
        {
          type: 'select',
          field: 'visit_area',
          label: '申请园区',
          // storeOptions: 'areaType',
          options: constantToOptions(areaTypeConst),
        },
      ],
    },
    {
      name: '被访信息',
      id: 'interviewee',
      formItem: [
        {
          type: 'input',
          field: 'interviewee_name',
          label: '被访问人',
        },
        {
          type: 'input',
          field: 'interviewee_phone',
          label: '被访问人电话',
        },
        {
          type: 'select',
          field: 'interviewee_depart_id',
          storeOptions: 'dept',
          label: '被访问单位',
        },
      ],
    },
  ])

  // 引用 multiple_form 以便重置时间
  const multipleFormRef = ref()

  async function handelSubmit(data) {
    // 校验时间差
    const beginTime = dayjs(data.visit_begin_time)
    const endTime = dayjs(data.visit_end_time)
    const diffDays = endTime.diff(beginTime, 'day')
    // 来访开始时间不能超过当天的1个月后
    const maxVisitTime = dayjs().add(1, 'month')
    if (beginTime.isAfter(maxVisitTime)) {
      message.warn('来访开始时间不能超过1个月')
      return
    }
    
    if (data.visitor_type === 1 && diffDays > 365) {
      message.warn('业主来访时间差不能超过1年')
      return
    } else if ([2, 3].includes(data.visitor_type) && diffDays > 180) {
      message.warn('服务商/建设单位来访时间差不能超过180天')
      return
    } else if (data.visitor_type === 4 && diffDays > 10) {
      message.warn('临时来访时间差不能超过10天')
      return
    }
    
    const ajaxFn = props.isEdit ? updateData : createData
    const messageText = props.isEdit ? '编辑' : '创建'
    const id = props.isEdit
      ? { [props.idField]: props.editData[props.idField] }
      : {}
    const res = await ajaxFn({ ...data, ...id })
    if (res.success) {
      message.success(messageText + '成功！')
      emit('submit')
    } else {
      message.warn(messageText + '错误：', res.message)
    }
  }
</script>
